// extracted by mini-css-extract-plugin
export default {"changeParticipationModalContainer":"GN2Qzbmc9gs0FKzCIXIQ","title":"P6oNpsXwCEIOxix2Cz50","description":"HrbZRppII5EcZ94qBtwv","buttons":"adgSwJzDJYWZve6Ey5gD"};